export default __webpack_public_path__ + "static/media/instructor-banner.948ca686.jpeg";